// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vM3X","index":"styles_index__2IxOR"};